var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/*
 * Copyright 2019 the original author or authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @author Steven Gentens
 * @since 2.2.0
 */
import BaseControlAdapter from '../support/base-control-adapter';
import { createControlValueHolder } from '../support/bootstrap-ui-control-value-holder';
import * as $ from 'jquery';
/**
 * {@link BootstrapUiControlAdapter} for <a href="https://github.com/twitter/typeahead.js">typeahead</a> autosuggest elements.
 * The target of the control adapter is the typeahead initialized node.
 *
 * To prevent a value being present when no value is effectively selected, the value of the control will be cleared when the suggestion list is shown.
 * This will ensure that a {@link BootstrapUiControlAdapter#CHANGE} event is triggered without a value (but with a label), but not whilst the user is refining his search.
 *
 * @see autosuggestInitializer
 */
var AutosuggestControlAdapter = /** @class */ (function (_super) {
    __extends(AutosuggestControlAdapter, _super);
    function AutosuggestControlAdapter(wrapper) {
        var _this = this;
        var typeahead = $(wrapper).find('.js-typeahead.tt-input');
        _this = _super.call(this, typeahead[0]) || this;
        $(typeahead).on('typeahead:change', function (event) { return _this.triggerChange(); });
        $(typeahead).on('typeahead:open', function (event) {
            $(_this.valueHolder).val(null);
            _this.triggerChange();
        });
        $(typeahead).on('typeahead:select', function (event) { return _this.triggerChange(); });
        // TODO configure 'bootstrapui.submit' event
        // $( typeahead ).keypress( this, ( event ) => {
        //     if ( event.key === 'Enter' ) {
        //         // event.preventDefault();
        //         this.triggerSubmit();
        //     }
        // } );
        var typeaheadValue = $(wrapper).find('.js-typeahead-value');
        _this.valueHolder = typeaheadValue[0];
        _this.initialValue = { label: typeahead.typeahead('val'), value: typeaheadValue.val() };
        return _this;
    }
    AutosuggestControlAdapter.prototype.getValue = function () {
        var label = $(this.getTarget()).typeahead('val');
        var value = $(this.valueHolder).val();
        return [createControlValueHolder(label, value, { typeahead: this.getTarget(), typeaheadValue: this.valueHolder })];
    };
    AutosuggestControlAdapter.prototype.reset = function () {
        this.selectValue(this.initialValue);
    };
    AutosuggestControlAdapter.prototype.selectValue = function (newValue) {
        $(this.getTarget()).typeahead('val', newValue.label);
        $(this.valueHolder).val(newValue.value);
    };
    return AutosuggestControlAdapter;
}(BaseControlAdapter));
export default AutosuggestControlAdapter;
/**
 * Initializes a {@link AutosuggestControlAdapter} for a given node.
 *
 * @param node to initialize
 */
export function createAutosuggestControlAdapter(node) {
    return new AutosuggestControlAdapter(node);
}
